import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { deleteGroupItemSuccess, deleteGroupItemFailure } from '../actions';
import GroupActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* deleteGroupItem({ payload }) {
  const url = `${API_BASE_URL}/application-group-items/${payload.item}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  if (response.success) {
    yield put(deleteGroupItemSuccess(payload.item));
    Notify('Group Item Deleted Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    payload.cb();
    yield put(
      deleteGroupItemFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    
  }
}

export function* onDeleteGroupItem() {
  yield takeLatest(GroupActionTypes.DELETE_GROUP_ITEM, deleteGroupItem);
}
